import { type App, defineAsyncComponent as dAC } from 'vue'
import StellaButton from './StellaButton.vue'
import StellaTooltip from './StellaTooltip.vue'

const StellaAvatar = dAC(() => import('./StellaAvatar.vue'))
const StellaBadge = dAC(() => import('./StellaBadge.vue'))
const StellaAsyncButton = dAC(() => import('./StellaAsyncButton.vue'))
const StellaCard = dAC(() => import('./StellaCard.vue'))
const StellaCarousel = dAC(() => import('./StellaCarousel.vue'))
const StellaCheckbox = dAC(() => import('./StellaCheckbox.vue'))
const StellaChecklist = dAC(() => import('./StellaChecklist.vue'))
const StellaColorPicker = dAC(() => import('./StellaColorPicker.vue'))
const StellaCosmeticPicker = dAC(
  () => import('./StellaCosmeticPicker/StellaCosmeticPicker.vue'),
)
const StellaDivider = dAC(() => import('./StellaDivider.vue'))
const StellaEditableText = dAC(() => import('./StellaEditableText.vue'))
const StellaEmptyState = dAC(() => import('./StellaEmptyState.vue'))
const StellaGroupedChecklist = dAC(() => import('./StellaGroupedChecklist.vue'))
const StellaImage = dAC(() => import('./StellaImage.vue'))
const StellaImageTile = dAC(() => import('./StellaImageTile.vue'))
const StellaInfoBox = dAC(() => import('./StellaInfoBox.vue'))
const StellaInput = dAC(() => import('./StellaInput.vue'))
const StellaTextArea = dAC(() => import('./StellaTextArea.vue'))
const StellaLabeledCheckbox = dAC(() => import('./StellaLabeledCheckbox.vue'))
const StellaLabeledField = dAC(() => import('./StellaLabeledField.vue'))
const StellaLink = dAC(() => import('./StellaLink.vue'))
const StellaPriceDisplay = dAC(() => import('./StellaPriceDisplay.vue'))
const StellaSlider = dAC(() => import('./StellaSlider.vue'))
const StellaSliderInput = dAC(() => import('./StellaSliderInput.vue'))
const StellaSpinner = dAC(() => import('./StellaSpinner.vue'))
const StellaSwatch = dAC(() => import('./StellaSwatch.vue'))
const StellaTab = dAC(() => import('./StellaTab.vue'))
const StellaText = dAC(() => import('./StellaText.vue'))
const StellaToggle = dAC(() => import('./StellaToggle.vue'))
const StellaIcon = dAC(() => import('./icons/StellaIcon.vue'))
const StellaSearchInput = dAC(() => import('./search/StellaSearchInput.vue'))
const StellaSearchFilterButton = dAC(
  () => import('./search/StellaSearchFilterButton.vue'),
)
const StellaChoice = dAC(() => import('./StellaChoice/StellaChoice.vue'))
const StellaFab = dAC(() => import('./StellaFab/StellaFab.vue'))
const StellaFeatureHint = dAC(
  () => import('./StellaFeatureHint/StellaFeatureHint.vue'),
)
const StellaLoader = dAC(() => import('./StellaLoader/StellaLoader.vue'))
const StellaMenu = dAC(() => import('./StellaMenu/StellaMenu.vue'))
const StellaMenuList = dAC(() => import('./StellaMenu/StellaMenuList.vue'))
const StellaNakedMenuList = dAC(
  () => import('./StellaMenu/StellaNakedMenuList.vue'),
)
const StellaMenuPanel = dAC(() => import('./StellaMenu/StellaMenuPanel.vue'))
const StellaNavBar = dAC(() => import('./StellaNavBar/StellaNavBar.vue'))
const StellaNavToolbar = dAC(
  () => import('./StellaNavBar/StellaNavToolbar.vue'),
)
const StellaNavTopbar = dAC(() => import('./StellaNavBar/StellaNavTopbar.vue'))
const StellaMultiSelect = dAC(
  () => import('./StellaSelect/StellaMultiSelect.vue'),
)
const StellaModalContent = dAC(
  () => import('./StellaModal/StellaModalContent.vue'),
)
const StellaDesignerTag = dAC(() => import('./StellaDesignerTag.vue'))
const StellaIllustration = dAC(
  () => import('./illustrations/StellaIllustration.vue'),
)
const StellaProTip = dAC(() => import('./StellaProTip.vue'))
const StellaMenuButton = dAC(() => import('./StellaMenuButton.vue'))
const StellaEdgeObserver = dAC(() => import('./StellaEdgeObserver.vue'))
const StellaPill = dAC(() => import('./StellaPill.vue'))

export default {
  install(app: App) {
    // installing Stella components

    app.component('StellaAvatar', StellaAvatar)
    app.component('StellaBadge', StellaBadge)
    app.component('StellaButton', StellaButton)
    app.component('StellaAsyncButton', StellaAsyncButton)
    app.component('StellaCard', StellaCard)
    app.component('StellaCarousel', StellaCarousel)
    app.component('StellaCheckbox', StellaCheckbox)
    app.component('StellaChecklist', StellaChecklist)
    app.component('StellaColorPicker', StellaColorPicker)
    app.component('StellaCosmeticPicker', StellaCosmeticPicker)
    app.component('StellaDivider', StellaDivider)
    app.component('StellaEditableText', StellaEditableText)
    app.component('StellaEmptyState', StellaEmptyState)
    app.component('StellaGroupedChecklist', StellaGroupedChecklist)
    app.component('StellaImage', StellaImage)
    app.component('StellaImageTile', StellaImageTile)
    app.component('StellaInput', StellaInput)
    app.component('StellaTextArea', StellaTextArea)
    app.component('StellaLabeledCheckbox', StellaLabeledCheckbox)
    app.component('StellaLabeledField', StellaLabeledField)
    app.component('StellaLink', StellaLink)
    app.component('StellaPriceDisplay', StellaPriceDisplay)
    app.component('StellaSlider', StellaSlider)
    app.component('StellaSliderInput', StellaSliderInput)
    app.component('StellaSpinner', StellaSpinner)
    app.component('StellaSwatch', StellaSwatch)
    app.component('StellaTab', StellaTab)
    app.component('StellaText', StellaText)
    app.component('StellaToggle', StellaToggle)
    app.component('StellaTooltip', StellaTooltip)
    app.component('StellaIcon', StellaIcon)
    app.component('StellaInfoBox', StellaInfoBox)
    app.component('StellaSearchInput', StellaSearchInput)
    app.component('StellaSearchFilterButton', StellaSearchFilterButton)
    app.component('StellaChoice', StellaChoice)
    app.component('StellaFab', StellaFab)
    app.component('StellaFeatureHint', StellaFeatureHint)
    app.component('StellaLoader', StellaLoader)
    app.component('StellaMenu', StellaMenu)
    app.component('StellaMenuList', StellaMenuList)
    app.component('StellaNakedMenuList', StellaNakedMenuList)
    app.component('StellaMenuPanel', StellaMenuPanel)
    app.component('StellaNavBar', StellaNavBar)
    app.component('StellaNavToolbar', StellaNavToolbar)
    app.component('StellaNavTopbar', StellaNavTopbar)
    app.component('StellaMultiSelect', StellaMultiSelect)
    app.component('StellaModalContent', StellaModalContent)
    app.component('StellaDesignerTag', StellaDesignerTag)
    app.component('StellaIllustration', StellaIllustration)
    app.component('StellaProTip', StellaProTip)
    app.component('StellaMenuButton', StellaMenuButton)
    app.component('StellaEdgeObserver', StellaEdgeObserver)
    app.component('StellaPill', StellaPill)
  },
}
